import { postJSON } from 'utils/fetch'

export const postHomeownerRescheduleRequest = async (
  calendarId: string,
  eventId: string,
  body: Record<string, unknown>
) => {
  return await postJSON(`/homeowner_site_visits/${calendarId}/events/${eventId}`, body)
}
